module.exports = "<div class = \"filter-label\" [ngClass] = '{\"active\" : filterHandle.activeFilter}'\n (click) = selected()>\n{{label}} \n</div>"